(function () {
  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function buildModelIndex(data) {
    var modelIndex = {};

    Object.keys(data).forEach(function (brandId) {
      var brand = data[brandId];
      if (!brand) return;

      (brand.series || []).forEach(function (series) {
        (series.models || []).forEach(function (model) {
          if (!model || !model.name) return;

          var key = brandId + "::" + model.name.toLowerCase();
          var existing = modelIndex[key];

          if (!existing || (!existing.collection_url && model.collection_url) || (!existing.ref_url && model.ref_url)) {
            modelIndex[key] = {
              id: key,
              name: model.name || "",
              ref_url: model.ref_url || "",
              collection_url: model.collection_url || null,
              brandId: brandId,
              brandTitle: brand.title || "",
            };
          }
        });
      });
    });

    return modelIndex;
  }

  function sortByName(items) {
    return items.sort(function (a, b) {
      return (a.name || a.title || "").localeCompare(b.name || b.title || "", undefined, {
        sensitivity: "base",
        numeric: true,
      });
    });
  }

  function initBrandModelSelector(section) {
    if (!(section instanceof HTMLElement) || section.dataset.brandModelSelectorInit === "true") return;

    var data = window.brandModelData || {};
    var brandSelect = section.querySelector("[data-brand-select]");
    var modelSelect = section.querySelector("[data-model-select]");
    var results = section.querySelector("[data-brand-model-results]");

    if (!(brandSelect instanceof HTMLSelectElement) || !(modelSelect instanceof HTMLSelectElement)) return;

    section.dataset.brandModelSelectorInit = "true";

    var modelIndex = buildModelIndex(data);
    var brandList = sortByName(
      Object.keys(data).map(function (brandId) {
        var brand = data[brandId] || {};
        return {
          id: brandId,
          title: brand.title || "",
        };
      })
    );

    function replaceOptions(select, placeholder, items, mapLabel) {
      select.options.length = 0;
      select.add(new Option(placeholder, "", true, false));

      items.forEach(function (item) {
        select.add(new Option(mapLabel(item), item.id, false, false));
      });
    }

    function getModelsForBrand(brandId) {
      return sortByName(
        Object.keys(modelIndex)
          .map(function (key) {
            return modelIndex[key];
          })
          .filter(function (model) {
            return !brandId || model.brandId === brandId;
          })
      );
    }

    function clearResults() {
      if (results) {
        results.innerHTML = "";
      }
    }

    function renderResult(model) {
      if (!results) return;

      if (!model) {
        clearResults();
        return;
      }

      var actions = "";
      if (model.ref_url) {
        actions += '<a class="bm-btn bm-btn-primary" href="' + escapeHtml(model.ref_url) + '">Open model</a>';
      }
      if (model.collection_url) {
        actions += '<a class="bm-btn" href="' + escapeHtml(model.collection_url) + '">View collection</a>';
      }

      results.innerHTML =
        '<div class="bm-card">' +
        "<p><strong>Brand:</strong> " +
        escapeHtml(model.brandTitle) +
        "</p>" +
        "<p><strong>Model:</strong> " +
        escapeHtml(model.name) +
        "</p>" +
        '<div class="bm-actions">' +
        actions +
        "</div></div>";
    }

    replaceOptions(brandSelect, "All brands", brandList, function (brand) {
      return brand.title;
    });
    replaceOptions(modelSelect, "Select model", getModelsForBrand(""), function (model) {
      return model.brandTitle ? model.name + " - " + model.brandTitle : model.name;
    });

    brandSelect.addEventListener("change", function () {
      replaceOptions(modelSelect, "Select model", getModelsForBrand(brandSelect.value), function (model) {
        return brandSelect.value ? model.name : model.name + " - " + model.brandTitle;
      });
      clearResults();
    });

    modelSelect.addEventListener("change", function () {
      var selectedModel = modelIndex[modelSelect.value];
      renderResult(selectedModel);

      if (selectedModel && selectedModel.ref_url) {
        window.location.href = selectedModel.ref_url;
      }
    });
  }

  function bootBrandModelSelectors() {
    document.querySelectorAll("[data-brand-model-selector]").forEach(initBrandModelSelector);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootBrandModelSelectors, { once: true });
  } else {
    bootBrandModelSelectors();
  }
})();
